/*globals Settings*/

var MgpSpa = (function ($) {
  'use strict';

  //hide toolbar dropdown menu if no items in it
  var setUpToolbarMenuItemsDisplay = function () {
    $('.toolbar-dropdown-container').each(function () {
      var $self = $(this);

      if ($self.find('li').length) {
        //hidden by default so items do not flicker on DOM load
        $self.show();
      }
    });
  };

  //Only ever show Bootstrap hamburger menu when there are menu items
  var setUpNavBarToggleDisplay = function () {
    var $navbar = $('#navbar');
    var $navbarLogout = $navbar.find('.logout');

    if (!$navbar.find('.toolbar-dropdown-container').find('li').length &&
      !$navbar.find('.support').length &&
      (!$navbarLogout.length || $navbarLogout.is(':empty'))) {
      var $mgpToolbar = $('#mgp-toolbar');

      //Outside the places that use toolbarV2 (financial plan, Wealth Studios, and SnapshotV2) still has breadcrumbs opened by hamburger menu in xs viewport so don't hide the hamburger menu in that case
      if ($mgpToolbar.hasClass('toolbarV2') || $mgpToolbar.hasClass('no-breadcrumbs')) {
        $('.navbar-toggle').addClass('hidden').removeClass('visible-xs-block');
      }
    }
  };

  var setUpPopupHandler = function () {
    $(document).on('click', 'a.popup', function () {
      var self = $(this),
        url = self.attr('href'),
        width = self.attr('data-popup-width') || 992,
        height = self.attr('data-popup-height') || 620,
        dataPopupName = self.attr('data-popup-name'),
        //kluge for popups on popups in ie,
        //null window name or window name with spaces does not always create new window.
        name = dataPopupName ? dataPopupName.replace(/ /g, '') : ('_window' + Math.floor(Math.random() * 10001)),
        settings = self.attr('data-popup-settings');

      if (settings) {
        if (settings.toLowerCase().indexOf('width') === -1) {
          settings += ',width=' + width;
        }
        if (settings.toLowerCase().indexOf('height') === -1) {
          settings += ',height=' + height;
        }
      }
      else {
        settings = 'resizable=yes,scrollbars=yes,status=no,width=' + width + ',height=' + height;
      }

      window.open(url, name, settings);
      return false;
    });
  };

  var setUpModals = function () {
    $(document).on('click', '.help-modal, .small-modal, .medium-modal, .large-modal', function (event) {
      var $dialog,
        $modalLink = $(this),
        modalTitle = $modalLink.data('modal-title') || null,
        modalClasses = $modalLink.attr('class').split(' '),
        modalClass = '',
        modalSize = '',
        modalRight = false,
        i = 0;

      for (i = 0; i < modalClasses.length; i++) {
        if (modalClasses[i].indexOf('-modal') > -1) {
          modalClass = modalClasses[i];
        }
      }

      if (modalClass === 'small-modal') {
        modalSize = 'small';
      }
      else if (modalClass === 'large-modal' || modalClass === 'help-modal') {
        modalSize = 'large';
        modalRight = true;
      }
      else {
        modalSize = '';
      }

      $.ajax({
        type: 'GET',
        url: $(this).attr('href'),
        beforeSend: function () {
          $dialog = bootbox.dialog({
            title: modalTitle,
            size: modalSize,
            className: modalRight ? 'modal-right' : '',
            onEscape: true,
            message: '<br/><h4><i class="fa spinner fa-spin fa-lg" aria-hidden="true"></i>&nbsp;' +
              'Please wait while we process your request ...</h4><br/>',
            buttons: {
              success: {
                label: 'OK',
                className: 'btn-done'
              }
            }
          });
          $dialog.attr('aria-modal', true);
          //Prevent help icons inside panel-heading from triggering panel toggle, i.e. (Case 8229)
          event.stopPropagation();
        },
        success: function (data) {
          $dialog.find('.bootbox-body').html(data);

          $dialog.find('.btn-cancel, .btn-back, .btn-close').on('click', function (event) {
            $dialog.modal('hide');
            event.preventDefault();
            return false;
          });
        }
      });

      event.preventDefault();
    });
  };

  //https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
  //feature detect if browser storage is available
  var StorageAvailable = function (type) {
    try {
      var storage = window[type],
        x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    }
    catch (e) {
      return false;
    }
  };

  var ClearSpaSessionStorage = function () {
    try {
      store.session.namespace('moneyguide.financial-zoomer.' + Settings.HouseholdId).clear();
      store.session.namespace('moneyguide.snapshot.' + Settings.HouseholdId).clear();
      store.session.namespace('moneyguide.wealthstudios.' + Settings.HouseholdId).clear();
    }
    catch (e) {
      return false;
    }
  }

  var setUpSignOff = function () {
    $(document).on('click', '.logout-link', function (e) {
      e.preventDefault();

      if (StorageAvailable('localStorage')) {
        //set and change value to fire storage event listener
        localStorage.setItem('mgpSessionLoggedOut', 'false');
        localStorage.setItem('mgpSessionLoggedOut', 'true');
      }

      //Jira MGINT-1218 - Give Institution-specific scripts (e.g. Dash Guest) a chance to fire a beacon
      //before we navigate away. Listeners should use navigator.sendBeacon
      //because this event is dispatched immediately before window.location changes.
      try {
        window.dispatchEvent(new CustomEvent('mgp:sessionTimeoutPreLogout'));
      } catch (e) {
        //Never let a listener failure block the sign-off flow
      }
      
      if (StorageAvailable('sessionStorage')) {
        sessionStorage.removeItem('mgpAdminLaunchedSession');
      }
      if (typeof Settings.SignOffUrl !== 'undefined') {
        ClearSpaSessionStorage();
        sessionStorage.setItem('mgpActiveTimerInitialized', 'false');
        MgpSpa.DisconnectAsideObserver();
        sessionStorage.removeItem('mgp-support-assistant-state');
        sessionStorage.removeItem('mgp-support-assistant-history');
        sessionStorage.removeItem('mgp-support-assistant-session');
        window.location.href = Settings.SignOffUrl;
      }
    });

    window.addEventListener('storage', function (e) {
      if (e.key === 'mgpSessionLoggedOut') {
        if (e.newValue === true || e.newValue === 'true') {
          if (typeof Settings.SignOffUrl !== 'undefined') {
            ClearSpaSessionStorage();
            sessionStorage.setItem('mgpActiveTimerInitialized', 'false');
            MgpSpa.DisconnectAsideObserver();
            sessionStorage.removeItem('mgp-support-assistant-state');
            sessionStorage.removeItem('mgp-support-assistant-history');
            sessionStorage.removeItem('mgp-support-assistant-session');
            window.location.href = Settings.SignOffUrl;
          }
        }
      }
    });
  };

  var setUpMobileMenu = function () {
    $('.zoomer-mobile-menu-btn').on('click', function () {
      var $zoomerMenu = $('#mgp-nav ul.progressbar');
      $zoomerMenu.toggleClass('is-active');
    });
  };

  var setUpReturnToMyPlans = function () {
    $('.return-to-my-plans').on('click', function (e) {
      e.preventDefault();

      var url = $(this).attr('href');

      if (url) {
        launchPage(url);
      }
    });
  };

  //Need this routine for the SPAs inside Zoomer because the SPAs need the <base> tag set and that breaks the skip to main content link
  //DON'T USE THIS FOR THE SINGLE PAGE CONVERSATION
  var setSkipToMainContentLink = function () {
    if (!Settings.InSinglePageConversation) {
      if (document.getElementById('skip-to-main-content-link')) {
        var link = document.getElementById('skip-to-main-content-link');

        link.href = window.location.href + link.getAttribute('href');
      };
    }
  };

  var listenForToolbarNavItemsState = function () {
    window.addEventListener('mgp:disableToolbarNavItems', function (e) {
      if (typeof (e.detail) !== 'undefined') {
        var logoutLinks = document.querySelectorAll('.logout-link'),
          breadcrumbLinks = document.querySelectorAll('.breadcrumb-link'),
          breadcrumbLink,
          breadcrumbTextElems,
          breadcrumbTextElem,
          i = 0;

        if (e.detail.disableToolbarNavItems) {
          for (i = 0; i < logoutLinks.length; i++) {
            logoutLinks[i].style.display = 'none';
          }

          for (i = 0; i < breadcrumbLinks.length; i++) {
            breadcrumbLink = breadcrumbLinks[i];

            breadcrumbTextElems = document.querySelectorAll('.breadcrumb-disabled-text');

            //create/show text non-link version of crumbs if they don't exist
            if (breadcrumbTextElems.length < breadcrumbLinks.length) {
              breadcrumbTextElem = document.createElement('span');
              breadcrumbTextElem.textContent = breadcrumbLink.textContent;
              breadcrumbTextElem.className = 'breadcrumb-disabled-text';
              breadcrumbLink.parentElement.appendChild(breadcrumbTextElem);
              breadcrumbLink.style.display = 'none';
            } else {
              for (i = 0; i < breadcrumbTextElems.length; i++) {
                breadcrumbTextElems[i].style.display = 'inline-block';
                breadcrumbLinks[i].style.display = 'none';
              }
            }
          }
        } else {
          for (i = 0; i < logoutLinks.length; i++) {
            logoutLinks[i].style.display = 'block';
          }

          breadcrumbTextElems = document.querySelectorAll('.breadcrumb-disabled-text');

          //hide text non-link version of crumbs if they exist
          for (i = 0; i < breadcrumbTextElems.length; i++) {
            breadcrumbTextElems[i].style.display = 'none';
          }

          for (i = 0; i < breadcrumbLinks.length; i++) {
            //Jira MGFUTURE-16347 - clear the inline display so CSS controls it (block in the V2 dropdown menu,
            //inline-block in the legacy breadcrumb bar). Forcing inline-block here made the
            //breadcrumb-dropdown hover highlight only span the link text width.
            breadcrumbLinks[i].style.display = '';
          }
        }
      }
    });
  };

  //event listener for SPA Profile personal info, estate, etc. so data is 
  //validated on breadcrumbs click before navigating away from SPA
  var listenToLeaveSPA = function () {
    window.addEventListener('mgp:addNotifyOnLeave', function () {
      MgpSpa.AddNotifyOnLeave = true;

      MgpSpa.NotifiedOnLeaveEvent = new CustomEvent('mgp:notifiedOnLeave');

      //either 'okToLeave' or 'removeNotifyOnLeave' should be sent from SPA if SPA has sent 'addNotifyOnLeave'
      var okToLeave = function (e) {
        if (e.detail.okToLeave) {
          MgpSpa.AddNotifyOnLeave = false;
          window.removeEventListener('mgp:okToLeave', okToLeave);
          MgpSpa.RedirectToUrl();
        }
      };
      window.addEventListener('mgp:okToLeave', okToLeave);

      var removeNotifyOnLeave = function () {
        MgpSpa.AddNotifyOnLeave = false;
        window.removeEventListener('mgp:removeNotifyOnLeave', removeNotifyOnLeave);
      };
      window.addEventListener('mgp:removeNotifyOnLeave', removeNotifyOnLeave);
    });
  };

  //event listener for SPA Profile when client name(s) are updated in SPA update them in the MoneyGuide toolbar
  var listenForSPAHouseholdUpdate = function () {
    window.addEventListener('mgp:notifyHouseholdUpdate', function (e) {

      if (typeof (e.detail) !== 'undefined') {
        var AND = ' and ',
          SPACE = ' ',
          fullNames = '',
          client = e.detail.client,
          coClient = e.detail.coClient,
          clientFirstName = typeof (client.firstName) !== 'undefined' ? client.firstName : '',
          clientLastName = typeof (client.lastName) !== 'undefined' ? client.lastName : '',
          coClientFirstName = typeof (coClient.firstName) !== 'undefined' ? coClient.firstName : '',
          coClientLastName = typeof (coClient.lastName) !== 'undefined' ? coClient.lastName : '',
          toolbarInvestorNamesElems = document.querySelectorAll('.toolbar-investor-names');

        if (toolbarInvestorNamesElems.length) {
          if (e.detail.isCoClientPresent) {
            if (clientLastName !== coClientLastName) {
              fullNames = clientFirstName + SPACE + clientLastName + AND + coClientFirstName + SPACE + coClientLastName;
            }
            else {
              fullNames = clientFirstName + AND + coClientFirstName + SPACE + coClientLastName;
            }
          } else {
            fullNames = clientFirstName + SPACE + clientLastName;
          }

          for (var i = 0; i < toolbarInvestorNamesElems.length; i++) {
            toolbarInvestorNamesElems[i].textContent = fullNames;
          }
        }
      }
    });
  };

  var listenForSPAPlanNameUpdate = function () {
    window.addEventListener('mgp:notifyPlanNameUpdate', function (e) {
      if (typeof (e.detail) !== 'undefined' && typeof (e.detail.planName) !== 'undefined') {
        var toolbarPlanNameElems = document.querySelectorAll('.toolbar-plan-name');

        if (toolbarPlanNameElems.length) {
          for (var i = 0; i < toolbarPlanNameElems.length; i++) {
            toolbarPlanNameElems[i].textContent = e.detail.planName;
          }
        }
      }
    });
  };

  var asideObserver = null;
  var householdDashboardNavObserver = null;

  //Used on Profile, AA Plan, etc. to hide top v2 menu on subpages
  var setupAsideObserver = function () {
    //Latches what we last applied. classList.add and remove run their update steps unconditionally, so
    //without this the class attribute on #mgp-fixed-nav is re-serialized on every mutation batch the SPA
    //produces even when nothing changed, which keeps re-waking the framed-in height observer in
    //MessageCustomData.js. Starts null so the first evaluation always applies.
    var isNavVisible = null;

    asideObserver = new MutationObserver(function () {
      if (document.querySelector('mg-profile-section, mg-asset-allocation-plan')) {
        let errorContainer = document.querySelector('mg-infrastructure-errors-shared-error');
        let asideElem = document.querySelector('mg-common-menus-section-menu-section-menu .c-app-aside');
        //The aside or an error being on screen is the only positive signal available here, so its
        //absence is what hides the nav on subpages. Both navs are server rendered with hidden, meaning
        //this observer reveals and then re-hides; it cannot skip the negative case the way the household
        //dashboard observer does, because nothing else would ever put the nav back.
        let showNav = !!(asideElem || errorContainer);

        if (showNav !== isNavVisible) {
          isNavVisible = showNav;
          document.getElementById('mgp-fixed-nav')?.classList.toggle('hidden', !showNav);
        }
      }
    });

    asideObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  //The household dashboard SPA owns its own routing, so watching the DOM is the only way to know which
  //page is mounted. The dashboard tiles page (the landing page) keeps the v2 top nav; the features page
  //brings its own header, so the top nav comes off.
  //Anything else - mid route change, error page - is deliberately left alone instead of defaulting one
  //way, so the nav does not flicker in the gap between one page unmounting and the next mounting.
  var setupHouseholdDashboardNavObserver = function () {
    var DASHBOARD_TILES = 'mg-financial-plans-household-dashboard-features-dashboard-tiles-index',
      DASHBOARD_FEATURES = 'mg-financial-plans-household-dashboard-features-dashboard-features-index',
      //Only the household dashboard renders this nav, so every other SPA bails before paying for a
      //second body-wide observer
      mgpFixedNav = document.querySelector('#mgp-fixed-nav.household-dashboard-nav'),
      //Latches what we last applied. The observer fires on every mutation batch the SPA produces, not
      //only on route changes, so without this the class attribute would be rewritten hundreds of times
      //per page, which keeps re-waking the framed-in height observer in MessageCustomData.js.
      isNavVisible = null;

    if (!mgpFixedNav) {
      return;
    }

    //Only the hidden class is set here. The space #zoomer reserves for the nav in presentation mode is
    //released in CSS by _MenuV2.cshtml, because PresentationView.js owns that attribute and two writers
    //on it race each other when presentation mode is toggled while the nav is hidden.
    var setNavVisible = function (isVisible) {
      if (isVisible === isNavVisible) {
        return;
      }

      isNavVisible = isVisible;

      mgpFixedNav.classList.toggle('hidden', !isVisible);
    };

    householdDashboardNavObserver = new MutationObserver(function () {
      if (document.querySelector(DASHBOARD_TILES)) {
        setNavVisible(true);
      } else if (document.querySelector(DASHBOARD_FEATURES)) {
        setNavVisible(false);
      }
    });

    householdDashboardNavObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  var init = function () {
    setUpToolbarMenuItemsDisplay();
    setUpNavBarToggleDisplay();
    setUpPopupHandler();
    setUpSignOff();
    setUpModals();
    setSkipToMainContentLink();
    setUpMobileMenu();
    setUpReturnToMyPlans();

    setupAsideObserver();
    setupHouseholdDashboardNavObserver();
    listenForToolbarNavItemsState();
    listenToLeaveSPA();
    listenForSPAHouseholdUpdate();
    listenForSPAPlanNameUpdate();
  };

  return {
    Init: init,
    AddNotifyOnLeave: false,
    UrlToNav: '',
    NotifiedOnLeaveEvent: null,

    DisconnectAsideObserver: function () { asideObserver?.disconnect(); },

    RedirectToUrl: function () {
      var url = MgpSpa.UrlToNav;
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      var hasSid = url.indexOf('sid=') !== -1;
      MgpSpa.DisconnectAsideObserver();
      window.location.href = hasSid ? url : url + separator + 'sid=' + Settings.sId;
    }
  };

}(jQuery));

document.addEventListener('DOMContentLoaded', function () {
  MgpSpa.Init();
});

//Used for breadcrumb items
function launchPage(url) {
  if (typeof (MgpSpa) !== 'undefined') {
    MgpSpa.UrlToNav = url;

    if (MgpSpa.AddNotifyOnLeave) {
      //notify SPA Profile that breadcrumb is clicked and trying to leave SPA
      window.dispatchEvent(MgpSpa.NotifiedOnLeaveEvent);
    } else {
      MgpSpa.RedirectToUrl();
    }
  }
  else {
    if (typeof (MgpSpa) !== 'undefined') { MgpSpa.DisconnectAsideObserver(); }
    window.location.href = url + '?sid=' + Settings.sId;
  }
}


